import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'app-pra-config',
  templateUrl: './pra-config.component.html',
  styleUrls: ['./pra-config.component.css']
})
/** pra-config component*/
export class PraConfigComponent implements OnInit {
  /** pra-config ctor */

  showModal: boolean;
  @ViewChild('dataTable', { static: false }) table;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  dataSet: any;
  UserPrdConfig: any; TaskList: any;
  buttonTitle = 'Add';
  constructor() {
    this.GetUserMasterList();
    this.GetTaskList();

  }
  ngOnInit() {
    $('#divBodyTable').css('height', (GlobalConstants.size.height) - 200);
  }
  GetTaskList(): void {
    ApiMethod.getMethod('/api/pra/tasklist').subscribe(
      result => {
        this.TaskList = result.datalist;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetUserMasterList() {
    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };
    ApiMethod.postMethod('api/prauserlist', dataParam).subscribe(
      result => {
        $("#LoadingImage").hide();

        this.dataSet = JSON.stringify(result.datalist); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.colList;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'PRA Config';
        dataItem.infoPopupID = 'UserID';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  GetUserProductivityConfigList(): void {
    
    ApiMethod.getMethod('/api/pra/userconfig/' + localStorage.aEID).subscribe(
      result => {
        this.UserPrdConfig = result.datalist;

        this.showModal = true; // Show-Hide Modal Check
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  PopupShow() {
    this.GetUserProductivityConfigList();

  }

  hide() {
    this.showModal = false;
  }

  conficId = 0;
  RemoveConfig(item) {
    this.conficId = item.Id
    ngswal({
      title: "Confirmation",
      text: "Do you want to Remove ?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnRemoveConfig').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  RemoveConfigConfirm() {
    let data = {
      Id: this.conficId
    }
    $("#LoadingImagePopup").show();
    ApiMethod.postMethod('api/pra/deleteconfig', data).subscribe(
      response => {
        $("#LoadingImagePopup").hide();
        if (response.status) {
          ngswal("info !", response.message, "info");
          this.ResetControls();
          this.GetUserProductivityConfigList();
        }
        else {
          ngswal("Failed !", response.message, "error");
        }
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  ModifyConfig(item) {
    if (item != null) {
      this.buttonTitle = 'Update';
      $('#ddlTaskName').val(item.TaskId).change();
      $('#TxtRangeStart').val(item.CapacityStartRange);
      $('#TxtRangeEnd').val(item.CapacityEndRange);
      $('#TxtProductivity').val(item.Productivity);
      $('#ddlRangeType').val(item.RangeType);
    }
    else {
      this.ResetControls();
    }
  }

  UpdateConfig() {

    if ($('#ddlTaskName').val() == '0') {
      ngswal("Failed !", "Please select Task", "error");
    }
    else if ($('#TxtRangeStart').val() == '0') {
      ngswal("Failed !", "Please Enter Capacity Start", "error");
    }
    else if ($('#TxtRangeEnd').val() == '0') {
      ngswal("Failed !", "Please Enter Capacity End", "error");
    }
    else if ($('#TxtProductivity').val() == '0') {
      ngswal("Failed !", "Please Enter Productivity %", "error");
    }
    else {


      let data = {
        Id: 0,
        UserId: localStorage.aEID,
        PublihserId: localStorage.aPubID,
        TaskId: $('#ddlTaskName').val(),
        CapacityStartRange: $('#TxtRangeStart').val(),
        CapacityEndRange: $('#TxtRangeEnd').val(),
        Productivity: $('#TxtProductivity').val(),
        RangeType: $('#ddlRangeType').val(),
        UpdatedBy: localStorage.aLoginID,
      }

      $("#LoadingImagePopup").show();
      ApiMethod.postMethod('api/pra/updateconfig', data).subscribe(
        response => {
          $("#LoadingImagePopup").hide();
          if (response.status) {
            ngswal("info !", response.message, "info");
            this.ResetControls();
            this.GetUserProductivityConfigList();
          }
          else {
            ngswal("Failed !", response.message, "error");
          }
        }, error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.message, "warning");
        });
    }
  }

  ResetControls(): void {
    this.buttonTitle = 'Add';
    $('#ddlTaskName').val(0).change();
    $('#TxtRangeStart').val(0);
    $('#TxtRangeEnd').val(0);
    $('#TxtProductivity').val(0);
    $('#ddlRangeType').val('Day');
  }

}


